import { useState } from "react";

import * as Api from "../../../Api";

export function useSignup() {
  const INITIAL_STATE = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
    companyAddressStreet: "",
    companyAddressCity: "",
    companyAddressState: "",
    companyAddressZip: "",
    licenseNumber: "",
    password: "",
    confirmPassword: "",
    referralCode: "",
    hasConsented: false,
    role: "Super Admin",
    source: '',
    turnstileToken: ""
  };
  const [formData, setFormData] = useState(INITIAL_STATE);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isDone, setIsDone] = useState(false);
  const [isExistingUser, setIsExistingUser] = useState(false);
  // Incremented to tell the Turnstile widget to reset, since tokens are single-use
  const [turnstileResetCount, setTurnstileResetCount] = useState(0);

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords must match");
      return;
    }

    if (formData.password.length < 8) {
      setError("Password must have at least 8 characters");
      return;
    }

    if (!formData.hasConsented) {
      setError("You must agree to the terms to proceed");
      return;
    }

    if (!formData.turnstileToken) {
      setError("Please complete the verification challenge");
      return;
    }

    signup();
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  async function signup() {
    setIsLoading(true);

    try {
      await Api.Auth.signup(formData);
      setIsDone(true);
      scrollTop();
      setFormData(INITIAL_STATE);
    } catch (err) {
      setFormData((prev) => ({ ...prev, turnstileToken: "" }));
      setTurnstileResetCount((count) => count + 1);

      const msg = err.response?.data?.errors?.[0]?.msg;
      if (msg?.toLowerCase().includes('an account already exists with this email')) {
        setIsExistingUser(true);
      } else {
        const error = Api.getError(err);
        setError(error);
      }
    } finally {
      setIsLoading(false);
    }
  }

  const clearIsDone = () => setIsDone(false);
  const clearExistingUser = () => setIsExistingUser(false);

  return {
    formData,
    onChange,
    isLoading,
    error,
    handleSubmit,
    isDone,
    clearIsDone,
    isExistingUser,
    clearExistingUser,
    turnstileResetCount
  };
}
